(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('PriceInfoCustom', PriceInfoCustom);

    PriceInfoCustom.$inject = ['$resource'];

    function PriceInfoCustom($resource) {


        var PriceInfosByServiceItem = function (serviceItemId) {
            var resourceUrl = 'api/price-infos-by-service-item/' + serviceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var deletePriceInfoWithRelationsById = function (priceInfoId) {
            var resourceUrl = 'api/delete-price-info-with-relations-by-price-info-id/' + priceInfoId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getPriceInfoWithDtailById = function (priceInfoId) {
            var resourceUrl = 'api/get-price-info-with-dtails-by-price-info-id/' + priceInfoId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getPriceInfosWithDtailsByServiceItem = function (serviceItemId) {
            var resourceUrl = 'api/get-price-infos-with-dtails-by-service-item-id/' + serviceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            PriceInfosByServiceItem: PriceInfosByServiceItem,
            deletePriceInfoWithRelationsById: deletePriceInfoWithRelationsById,
            getPriceInfoWithDtailById: getPriceInfoWithDtailById,
            getPriceInfosWithDtailsByServiceItem: getPriceInfosWithDtailsByServiceItem
        };
    }
})();
